import type { FC } from 'react'

import { E_CertificateTypes } from '@/enums'
import logoPyaterochkaPng from '@/img/logo-pyaterochka.png?inline'
import logoPyaterochkaBuyCertPng from '@/img/logo-pyaterochka-buy-cert.png?inline'
import logoMagnitPng from '@/img/logo-magnit.png?inline'
import logoMagnitBuyCertPng from '@/img/logo-magnit-buy-cert.png?inline'
import logoVkusvillPng from '@/img/logo-vkusvill.jpg?inline'
import logoVkusvillBuyCertPng from '@/img/logo-vkusvill-buy-cert.png?inline'

import {
  SC_CertificateTop,
  SC_CertificateOrganizationLogo,
  SC_CertificateOrganizationTitle,
  SC_CertId,
} from './styled'


interface T_OrganizationBannerProps {
  certificateId: number
  certificateType: E_CertificateTypes | null
  isShowId?: boolean
  buyCertificate?: boolean
}

export const OrganizationBanner: FC<T_OrganizationBannerProps> = ({
  certificateId,
  certificateType,
  isShowId,
  buyCertificate,
}) => {
  if (!certificateType) return null


  return (
    <SC_CertificateTop>
      <SC_CertificateOrganizationLogo isBuyCertificate={buyCertificate}>
        {buyCertificate ? (
          <img src={
            certificateType === E_CertificateTypes.Pyaterochka
              ? logoPyaterochkaBuyCertPng
              : certificateType === E_CertificateTypes.Magnit
                ? logoMagnitBuyCertPng
                : logoVkusvillBuyCertPng
          } />
        ) : (
          <img src={
            certificateType === E_CertificateTypes.Pyaterochka
              ? logoPyaterochkaPng
              : certificateType === E_CertificateTypes.Magnit
                ? logoMagnitPng
                : logoVkusvillPng
          } />
        )
        }
        
      </SC_CertificateOrganizationLogo>

      <SC_CertificateOrganizationTitle>
        <span>
          {certificateType === E_CertificateTypes.Pyaterochka
            ? 'Пятёрочка'
            : certificateType === E_CertificateTypes.Magnit
              ? 'Магнит'
              : 'ВкусВилл'
          }
        </span>

        <span>Продукты</span>
      </SC_CertificateOrganizationTitle>

      {!isShowId && (
        <SC_CertId>
          {certificateId <= 0 ? 'Сертификат оформляется' : `#${certificateId}`}
        </SC_CertId>
      )}
    </SC_CertificateTop>
  )
}
